import { type UseModalState } from "@clipboard-health/ui-react";
import { Dialog, DialogContent, DialogTitle, Stack } from "@mui/material";
import { type RecentlyVisitedPage } from "@src/appV2/lib/utils/useRecentlyVisited";

import { Button } from "../../components/Button";
import { IconButton } from "../../components/IconButton";

interface RecentlyViewedDialogProps {
  modalState: UseModalState;
  recentVisited: RecentlyVisitedPage[] | undefined;
  onUserClicked: (recentlyVisitedPage: RecentlyVisitedPage) => void;
}

export function RecentlyViewedDialog(props: RecentlyViewedDialogProps) {
  const { modalState, recentVisited, onUserClicked } = props;

  if (!recentVisited) {
    return null;
  }

  return (
    <Dialog fullWidth open={modalState.modalIsOpen} maxWidth="sm" onClose={modalState.closeModal}>
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          Recently Viewed Accounts
          <IconButton
            size="small"
            variant="secondary"
            iconType="close"
            onClick={modalState.closeModal}
          />
        </Stack>
      </DialogTitle>
      <DialogContent
        sx={{
          maxHeight: "60vh",
          minHeight: "25vh",
          overflow: "auto",
        }}
      >
        <Stack spacing={3}>
          {recentVisited.map((item) => (
            <Button
              key={item.id}
              fullWidth
              variant="outlined"
              endIconType="hyperlink"
              onClick={() => {
                modalState.closeModal();
                onUserClicked(item);
              }}
            >
              {item.title}
            </Button>
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
